export default "__VITE_ASSET__DsX2sxqt__"